module.exports = __webpack_public_path__ + "static/media/599.756(36).285beb50.pdf";